import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";
import {SearchFormResultsWrapperDefaultBox} from "./search-form-results-wrapper.default.box";
import {SearchFormResultsWrapperCasino777Box} from "./search-form-results-wrapper.casino777.box";

export const SearchFormResultsWrapperBox = styledByTheme(SearchFormResultsWrapperDefaultBox)
.forCasino777(SearchFormResultsWrapperCasino777Box)
.apply();